(function () {
  const root = document.querySelector('[data-mg-home]');
  if (!root) return;

  const finePointer = matchMedia('(pointer:fine)').matches;
  const reduceMotion = matchMedia('(prefers-reduced-motion:reduce)').matches;
  const glow = root.querySelector('[data-mg-glow]');
  const hero = root.querySelector('[data-mg-hero]');

  if (finePointer && !reduceMotion) {
    window.addEventListener('pointermove', (event) => {
      if (glow) {
        glow.style.left = `${event.clientX}px`;
        glow.style.top = `${event.clientY}px`;
      }
      if (hero) {
        const rect = hero.getBoundingClientRect();
        const x = Math.max(0, Math.min(1, (event.clientX - rect.left) / rect.width));
        const y = Math.max(0, Math.min(1, (event.clientY - rect.top) / rect.height));
        hero.style.setProperty('--mx', `${x * 100}%`);
        hero.style.setProperty('--my', `${y * 100}%`);
      }
    }, { passive: true });

    root.querySelectorAll('.mg-card').forEach((card) => {
      card.addEventListener('pointermove', (event) => {
        const rect = card.getBoundingClientRect();
        const x = (event.clientX - rect.left) / rect.width - 0.5;
        const y = (event.clientY - rect.top) / rect.height - 0.5;
        card.style.transform = `perspective(900px) rotateX(${-y * 2.4}deg) rotateY(${x * 2.4}deg) translateY(-3px)`;
      });
      card.addEventListener('pointerleave', () => { card.style.transform = ''; });
    });
  }

  if ('IntersectionObserver' in window && !reduceMotion) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -30px' });
    root.querySelectorAll('.mg-reveal').forEach((item) => observer.observe(item));
  } else {
    root.querySelectorAll('.mg-reveal').forEach((item) => item.classList.add('is-visible'));
  }

  const mobileNav = root.querySelector('[data-mg-mobile-nav]');
  const menuButton = root.querySelector('[data-mg-menu]');
  const menuClose = root.querySelector('[data-mg-menu-close]');
  const toggleMenu = (open) => {
    if (!mobileNav) return;
    mobileNav.classList.toggle('is-open', open);
    mobileNav.setAttribute('aria-hidden', String(!open));
    menuButton?.setAttribute('aria-expanded', String(open));
    document.documentElement.style.overflow = open ? 'hidden' : '';
    if (open) menuClose?.focus();
    else menuButton?.focus();
  };
  menuButton?.addEventListener('click', () => toggleMenu(true));
  menuClose?.addEventListener('click', () => toggleMenu(false));
  mobileNav?.querySelectorAll('a').forEach((anchor) => anchor.addEventListener('click', () => toggleMenu(false)));
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && mobileNav?.classList.contains('is-open')) toggleMenu(false);
  });

  const crystalShowcase = root.querySelector('[data-crystal-showcase]');
  if (crystalShowcase) {
    const crystalButtons = [...crystalShowcase.querySelectorAll('[data-crystal-button]')];
    const crystalPanels = [...crystalShowcase.querySelectorAll('[data-crystal-panel]')];
    const selectCrystal = (key) => {
      crystalButtons.forEach((button) => {
        const active = button.dataset.crystalButton === key;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-selected', String(active));
      });
      crystalPanels.forEach((panel) => panel.classList.toggle('is-active', panel.dataset.crystalPanel === key));
    };
    crystalButtons.forEach((button, index) => {
      button.addEventListener('click', () => selectCrystal(button.dataset.crystalButton));
      button.addEventListener('keydown', (event) => {
        if (event.key !== 'ArrowDown' && event.key !== 'ArrowRight' && event.key !== 'ArrowUp' && event.key !== 'ArrowLeft') return;
        event.preventDefault();
        const direction = event.key === 'ArrowDown' || event.key === 'ArrowRight' ? 1 : -1;
        const next = crystalButtons[(index + direction + crystalButtons.length) % crystalButtons.length];
        next.focus();
        selectCrystal(next.dataset.crystalButton);
      });
    });
  }

  root.querySelectorAll('.mg-card__form').forEach((form) => {
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      const button = form.querySelector('button');
      const original = button.textContent;
      button.disabled = true;
      button.textContent = 'Adding…';
      try {
        const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(form.querySelector('[name="id"]').value), quantity: 1 }] })
        });
        if (!response.ok) throw new Error('Unable to add');
        button.textContent = 'Added ✓';
        setTimeout(() => { button.textContent = original; button.disabled = false; }, 1800);
      } catch (error) {
        button.textContent = 'Try again';
        button.disabled = false;
      }
    });
  });
})();
